import React, { useMemo } from 'react';
import { ABTestContext, GroupNumber } from '../../context/abTestContext';

interface ABTestComponentProps {
    children: React.ReactNode;
    previewGroup: GroupNumber;
    testNumber: number;
}

const ABTestComponent: React.FC<ABTestComponentProps> = ({ children, previewGroup = '1', testNumber }) => {
    const contextValue = useMemo(() => ({ previewGroup, testNumber }), [previewGroup, testNumber]);

    return <ABTestContext.Provider value={contextValue}>{children}</ABTestContext.Provider>;
};

export default ABTestComponent;
